import { getInitLanguage } from "@/pages/AccommodationPicking/hooks/useLanguageURLParams.ts";
import i18n from "i18next";
import LocalStorageBackend from "i18next-localstorage-backend";
import { initReactI18next } from "react-i18next";
import * as translationCS from "./locales/cs-translation.json";
import * as translationDE from "./locales/de-translation.json";
import * as translationEN from "./locales/en-translation.json";
import * as translationFR from "./locales/fr-translation.json";
import * as translationHR from "./locales/hr-translation.json";
import * as translationIT from "./locales/it-translation.json";
import * as translationSL from "./locales/sl-translation.json";
import * as translationSR from "./locales/sr-translation.json";

const resources = {
  hr: { translation: translationHR },
  en: { translation: translationEN },
  it: { translation: translationIT },
  de: { translation: translationDE },
  sl: { translation: translationSL },
  fr: { translation: translationFR },
  cs: { translation: translationCS },
  sr: { translation: translationSR },
};

// https://github.com/typescript-eslint/typescript-eslint/blob/HEAD/packages/eslint-plugin/docs/rules/no-floating-promises.md#ignorevoid
void i18n
  .use(initReactI18next)
  // all options here: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: getInitLanguage(),
    // if dev mode, show debug info
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },
    resources,
    backend: {
      backends: [LocalStorageBackend],
      backendOptions: [
        {
          expirationTime: 60 * 60 * 1000, // 1 hour
        },
      ],
    },
  });

// how to change language:
//  const changeLanguage = (lng) => {
//   i18n.changeLanguage(lng);
// };

export default i18n;
